import React from "react";
import { cancelAppointment } from "../../../../network/api/users/appointment/appointment";
import { useLoader } from "../../../../context/LoadingContext";
import { toast } from "react-toastify";
import Modal from "../../../../components/Modal";
import { logAppointmentEvent } from "../../../../services/analytics";
import { AppointmentAnalyticsChannel, AppointmentAnalyticsEvent } from "../../../../dto/analyticsDto";
import { Appointment } from "../../../../dto/interfaces";

interface CancelAppointmentModalProps {
  id: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setAppointment: React.Dispatch<React.SetStateAction<Appointment | null>>;
  token: string;
}

const CancelAppointmentModal: React.FC<CancelAppointmentModalProps> = ({
  id,
  open,
  setOpen,
  setAppointment,
  token,
}) => {
  const { setLoading } = useLoader();
  const CancelHandler = async () => {
    try {
      setLoading(true);
      const header = {
        Authorization: token,
      };

      const res:any = await cancelAppointment(id, header);
      toast.success("Appointment cancelled successfully");
      logAppointmentEvent({
        appointment: res as Appointment,
        action: AppointmentAnalyticsEvent.CANCELLED,
        channel: AppointmentAnalyticsChannel.PATIENT_WEB
      })
      setAppointment(res as Appointment);
    } catch (error:any) {
      toast.error("Error " + error.response.data.message);
      throw (error);

    } finally {
      setLoading(false);
      setOpen(false);
    }
  };
  return (
    <>
      <Modal
        isOpen={open}
        onClose={() => {
          setOpen(!open);
        }}
        onConfirm={CancelHandler}
        title="Cancel Appointment"
        cancelText="No"
        confirmText="Yes"
      >
        <h1 className="text-red-800 py-1">
          Are you sure you want to cancel this appointment?
        </h1>
      </Modal>
    </>
  );
};

export default CancelAppointmentModal;
